var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('svg-icon',_vm._g(_vm._b({class:_vm.iconSize,attrs:{"name":_vm.icon,"width":_vm.width || _vm.computedSize,"height":_vm.height || _vm.computedSize,"fill":_vm.computedColor}},'svg-icon',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }